import { NgModule } from '@angular/core';
import { RouterModule, Routes} from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { ProtectRouteService } from './services/protect-route.service';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {AuthGuardService as AuthGuard} from './services/auth/auth-guard.service';
import { CategoriaProductsComponent } from './modules/productos/categoria-productos/categoria-productos.component';
import { utensiliosComponent } from './modules/utensilios/categoria-utensilios/utensilios.component';
import { CategoriaParametrosComponent } from './modules/parametros/categoria-parametros/categoria-parametros.component';
import { tiritasComponent } from './modules/tiritas/categoria-tiritas/tiritas.component';
import { PesosComponent } from './modules/pesos/pesos.component';
import { ListPesosComponent } from './modules/pesos/list/list-pesos/list-pesos.component';
import { PesosGirsacComponent } from './modules/girsac/pesos.component';
import { ZumosCategoriaComponent } from './modules/zumos/zumos-categoria/zumos-categoria.component';
import { EtiquetaCategoriaComponent } from './modules/etiquetas/etiquetas-categoria/etiquetas-categoria.component';
import { UsuarioCategoriaComponent } from './modules/usuarios/usuarios-categoria/usuarios-categoria.component';
import { VariedadesCategoriaComponent } from './modules/variedades/variedades-categoria/variedades-categoria.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { CategoriaTestVidaComponent } from './modules/test-de-vida/categoria-test-de-vida/categoria-test-de-vida.component';
import { CategoriaConformidadComponent } from './modules/conformidad/categoria-conformidad/categoria-conformidad.component';
import { CategoriaTransporteComponent } from './modules/transporte/categoria-transporte/categoria-transporte.component';
import { rellenarMenUsuario } from './config/procedimientos_registros';
import { TipoResiduosCategoriaComponent } from './modules/tipo-residuos/tipo-residuos-categoria/tipo-residuos-categoria.component';
import { PesosCreateUpdateComponent } from './modules/pesos/create-update/pesosCreateUpdate.component';

import { UserResolver } from './resolvers/user.resolver';
import { GraficaCategoriaComponent } from './modules/grafica/grafica-categoria/grafica-categoria.component';
import { UbicacionCategoriaComponent } from './modules/SGAubicacion/ubicacion-categoria/ubicacion-categoria.component';
import { VehiculosCategoriaComponent } from './modules/vehiculos/vehiculos-categoria/vehiculos-categoria.component';


/**
 *  `getTitulo`  retrieves the title of a menu item based on its ID.
 * @param id - The `id` parameter is a string that represents the ID of a menu item.
 * @returns The function `getTitulo` returns an object from the `datosMenu` array that has a matching `id` property.
 * This result will be used to automatically print the title according to the procedures the client has
 */
let datosMenu = rellenarMenUsuario();

function getTitulo(id) {
    let auxData = datosMenu.find(function (objeto) { return objeto.id === id; });

    return auxData;
}


export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login'},
    { path:'login', component:LoginComponent},
   /*  { path: 'productos', component: ProductsComponent },
    { path: 'producto/crear', component: FormulariosComponent },
    { path: 'producto/:id', component: EditProductComponent },  */
    {
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], resolve: { user: UserResolver }, data: {titulo : 'Inicio'} ,
        children: [
            {path: 'inicio', redirectTo: '/dashboard', data: { titulo: 'Inicio'} },
            {
                path: 'limpieza',
                loadChildren:'./modules/limpieza/app.limpieza.modules#limpiezaModule',
                data: {titulo : 'Anexo II Control de limpieza y desinfección'}

            },
            {
                path: 'tiritas',
                component:tiritasComponent,
                loadChildren:'./modules/tiritas/app.tiritas.modules#TiritasModule',
                data: {titulo : 'Anexo IX Control de tiritas'}

            },
            {
                path: 'control',
                loadChildren:'./modules/control/app.control.modules#ControlCristalModule',
                data: {titulo : 'Anexo III Control de cristales, plásticos, luces y metales'}

            },
            {
                path: 'producto',
                component: CategoriaProductsComponent,
                loadChildren:'./modules/productos/app.productos.modules#productModule',
                data: {titulo : 'Anexo III Control de entradas de materia prima'}


            },
            {
                path: 'utensilios',
                component:utensiliosComponent,
                loadChildren:'./modules/utensilios/app.utensilios.modules#UtensiliosModule',
                data: {titulo : 'Anexo VIII Control utensilios'}


            },
            {
                path: 'parametro',
                component:CategoriaParametrosComponent,
                loadChildren:'./modules/parametros/app.parametros.modules#ParametrosModule',
                data: {titulo : 'Anexo XII Control de parámetros en cámaras frigoríficas'}

            },
            {
                path: 'pesos',
                component:PesosComponent,
                data: {titulo : ''},

                children:
                [
                    {path: '', component:ListPesosComponent},
                    // {path: 'crear', component: PesosCreateComponent},
                    // {path: 'edit/:id', component: UpdatePesosComponent},
                    {path: 'crear', component: PesosCreateUpdateComponent, data: {titulo: 'Anexo VII Registro de control de pesos pitufo'}},
                    {path: 'edit/:id', component: PesosCreateUpdateComponent, data: {titulo: 'Anexo VII Registro de control de pesos pitufo'}},
                   /*  {path: 'albums', component: ArtistAlbumListComponent},  */
                ]
                //loadChildren:'./modules/parametros/app.parametros.modules#ParametrosModule'

            },
            {
                path: 'girsac',
                component:PesosGirsacComponent,
                loadChildren:'./modules/girsac/app.girsac.modules#GirsacModule',
                data: {titulo : 'Anexo VII.bis Registro de control de pesos malla (girsac)'}



            },
            {
                path: 'zumos',
                component:ZumosCategoriaComponent,
                loadChildren:'./modules/zumos/app.zumos.modules#ZumosModule',
                data: {titulo :''}

            },
            {
                path: 'etiquetas',
                component:EtiquetaCategoriaComponent,
                loadChildren:'./modules/etiquetas/app.etiquetas.modules#EtiquetasModule',
                data: {titulo : ''}


            },
            {

                path: 'usuarios',
                component:UsuarioCategoriaComponent,
                loadChildren:'./modules/usuarios/app.usuario.modules#UsuarioModule',
                data: {titulo : 'Control de usuarios'}

            },
            {
                path: 'grafica',
                component: GraficaCategoriaComponent,
                loadChildren: "./modules/grafica/app.grafica.modules#GraficaModule",
                data: {titulo: 'Gráfica'}
            },
            {

                path: 'variedades',
                component:VariedadesCategoriaComponent,
                loadChildren:'./modules/variedades/app.variedades.modules#VariedadesModule',
                data: {titulo : 'Variedades'},
            },
            {
                path: 'vehiculos',
                component:VehiculosCategoriaComponent,
                loadChildren:'./modules/vehiculos/app.vehiculos.modules#VehiculosModule',
                data: {titulo: 'Vehiculos'},
            },
            {

                path: 'variedades_fruto_hueso',
                component:VariedadesCategoriaComponent,
                loadChildren:'./modules/variedades_fruto_hueso/app.variedades-fruto-hueso.modules#VariedadesFrutoSecoModule',
                data: {titulo : 'Variedades fruto hueso'},
            },
            {

                path: 'tipo_residuos',
                component:TipoResiduosCategoriaComponent,
                loadChildren:'./modules/tipo-residuos/app.tipo-residuos.modules#TipoResiduosModule',
                data: {titulo : 'Tipos de residuos'},
            },
            {

                path: 'paises',
                component:VariedadesCategoriaComponent,
                loadChildren:'./modules/paises/app.pasies.modules#PaisesModule',
                data: {titulo : 'Países'}
            },

            {
                path: 'empresas',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/empresas/app.empresas.modules#EmpresasModule',
                data: {titulo : 'Empresas'}

            },

            {
                path: 'documentos',
                component:DocumentosComponent,
                data: {titulo : 'Generar copia de seguridad'}
            },
            {
                path: 'test-de-vida-comercial',
                component:CategoriaTestVidaComponent,
                loadChildren:'./modules/test-de-vida/app.test-de-vida.modules#TestVidaModule',
                data: {titulo : 'Anexo IV Test de vida comercial '}

            },
            {
                path: 'control-de-conformidad',
                component:CategoriaConformidadComponent,
                loadChildren:'./modules/conformidad/app.conformidad.modules#ConformidadModule',
                data: {titulo : 'Anexo V Control de conformidad'}

            },
            {
                path: 'transporte',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/transporte/app.transporte.modules#ControlTransporteModule',
                data: {titulo : 'Anexo IV Datos del transporte'}

            },
            {
                path: 'transporte-rutas',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/transporte-rutas/app.transporte-rutas.modules#ControlTransporteRutasModule',
                data: {titulo : 'Transporte rutas'}

            },
            {
                path: 'mantenimiento-camiones',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/mantenimiento-camiones/app.mantenimiento-camiones.modules#ControlTransporteRutasModule',
                data: {titulo : 'Mantenimiento camiones'}

            },
            {
                path: 'agua-cloro',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/agua-cloro/app.agua-cloro.modules#AguaCloroModule',
                data: {titulo : 'Agua cloro'}
            },
            {
                path: 'agua',
                loadChildren:'./modules/agua/app.agua.modules#AguaModule',
                data: {titulo : 'Control Agua'}


            },
            {
                path: 'prod_camion',
                loadChildren:'./modules/prod_camion/app.prod_camion.modules#ProdCamionModule',
                data: {titulo : 'Productos camión'}


            },
            {
                path: 'limpieza_desinfeccion',
                loadChildren:'./modules/limpieza_camion/app.limpieza_camiones.modules#limpiezaCamionesModule',
                data: {titulo : 'Anexo II.bis Limpieza y desinfección -camiones- '}
            },
            {
                path: 'inventario_residuos',
                loadChildren:'./modules/inventario-residuos/app.inventario-residuos.modules#InventarioResiduosModule',
                data: {titulo : 'Anexo I. Inventario general de residuos '}
            },
            {
                path: 'plano_residuos',
                loadChildren:'./modules/plano-residuos/app.plano-residuos.modules#PlanoResiduosModule',
                data: {titulo : 'Anexo II. Plano gestión de residuos '}
            },
            {
                path: 'prod_post_cosecha',
                loadChildren:'./modules/prod_post_cosecha/app.prod_post_cosecha.modules#ProdCosechaModule',
                data: {titulo : 'Prod post cosecha'}
            },
            // TODO add module tratamientos
            // {
            //     path: 'tratamientos',
            //     loadChildren:'./modules/prod_post_cosecha/app.prod_post_cosecha.modules#ProdCosechaModule',
            //     data: {titulo : 'Tratamientos'}
            // },
            {
                path: 'encerado',
                loadChildren:'./modules/encerado/app.encerado.modules#EnceradosModule'
                ,data: {titulo : 'Anexo I Control Productos Postcosecha Cera'}

            },
            {
                path: 'online',
                loadChildren:'./modules/online/app.online.modules#OnlineModule'
                ,data: {titulo : 'Anexo I bis Control Productos Postcosecha Online'}

            },
            {
                path: 'lavadora',
                loadChildren:'./modules/lavadora/app.lavadora.modules#LavadoraModule'
                ,data: {titulo : 'Anexo II Control Productos Postcosecha Lavadora'}
            },
            {
                path: 'etileno',
                loadChildren:'./modules/etileno/app.etileno.modules#EtilenoModule'
            },
            {
                path: 'nebulizador',
                loadChildren:'./modules/nebulizador/app.nebulizador.modules#NebulizadorModule',
                data: {titulo : 'Control de nebulizador'}

            },
            {
                path: 'cuaderno_campo',
                loadChildren:'./modules/cuaderno-campo/app.cuaderno-campo.modules#CuadernoCampoModule',
                data: {titulo : 'Cuaderno de campo'},


            },
            {
                path: 'confecciones_diarias',
                loadChildren:'./modules/confecciones-diarias/app.confecciones-diarias.modules#ConfeccionDiariasModule',
                data: {titulo : 'Confección diarias'}
            },
            {
                path: 'plagas',
                loadChildren:'./modules/plagas/app.plagas.modules#PlagasModule',
                data: {titulo : 'Control de plagas'}

            },
            {
                path: 'camaras_etileno',
                loadChildren:'./modules/camaras-etileno/app.camaras-etileno.modules#CamarasEtilenoModule',
                data: {titulo : 'Cámaras de etileno'}

            },
            {
                path: 'residuos_no_peligrosos',
                loadChildren:'./modules/residuos-no-peligrosos/app.productos-no-peligrosos.modules#ProductoNoPeligrososModule',
                data: {titulo : 'Anexo III Libro de registro de residuos no peligrosos'}


            },
            {
                path: 'residuos_peligrosos',
                loadChildren:'./modules/residuos-peligrosos/app.productos-peligrosos.modules#ProductoPeligrososModule'
                ,data: {titulo : 'Anexo III.bis Libro de registro de residuos peligrosos'}


            },
            {
                path: 'control_linea',
                loadChildren:'./modules/control-linea/app.control-linea.modules#ControlLineaModule',
                data: {titulo : 'Control de línea'}

            },
            {
                path: 'diario_cogida',
                loadChildren:'./modules/diario-cogida/app.diario-cogida.modules#DiarioCogidaModule',
                data: {titulo : 'Control diario cogida '}

            },
            {
                path: 'peso_materia',
                loadChildren:'./modules/peso-materia-prima/apppeso-materia.modules#PesoMateriaModule',
                data: {titulo : 'Control peso entrada materia prima'}

            },
            {
                path: 'perdida_peso_no_pesada',
                loadChildren:'./modules/perdida-peso-diaria-no-pesada/app.perdida-peso-diaria-no-pesada.modules#PerdidaPesoDiariaNoPesadaModule',
                data: {titulo : 'Registro de entrada materia prima no pesada'}

            },
            {
                path: 'perdida_peso_diaria',
                loadChildren:'./modules/perdida-peso-diaria/app.perdida-peso-diaria.modules#PerdidaPesoDiariaModule',
                data: {titulo : 'Pérdida diaria de peso en la confección'}

            },
            {
                path: 'contra_incendios',
                loadChildren:'./modules/contra-incendios/app.contra-incendios.modules#ContraIncendiosModule',
                data: {titulo : 'Verificación instalaciones de protección contra incendios (anual- trimestral)'}
            },
            {
                path: 'plan_limpieza_desinfeccion',
                loadChildren:'./modules/plan-limpieza-desinfeccion/app.plan-limpieza-desinfeccion.modules#PlanLimiezaDesinfeccionModule',
                data: {titulo : 'Anexo III Plan de limpieza y desinfección'}


            },
            {
                path: 'reuniones',
                loadChildren:'./modules/reuniones/app.reuniones.modules#ReunionesModule',
                data: {titulo : 'Anexo III Listado de reuniones', database: 'reunion'}
            },
            {
                path: 'formacion',
                loadChildren:'./modules/formacion/app.formacion.modules#FormacionModule',
                data: {titulo : 'Anexo IV Control de formación'}

            },
           /*  {
                path: 'tratamiento_no_conformidad',
                loadChildren:'./modules/tratamiento-no-conformidad/app.tratamiento-no-conformidad.modules#TratamientoNoConformidadModule'
            }, */
            {
                path: 'tratamiento_no_conformidad',
                loadChildren:'./modules/fruto-hueso-no-conformidad/app.fruto-hueso-no-conformidad.modules#FrutoHuesoNoConformidadModule'
                ,data: {titulo : 'Anexo I Tratamiento de las no conformidades'}

            },
            {
                path: 'control_documentos',
                loadChildren:'./modules/control-documentos/app.control-documentos.modules#ControlDocumentosModule',
                data: {titulo: 'Anexo II Control de documentos'}
            },
            {
                path: 'control_certificados',
                loadChildren:'./modules/control-certificaciones/app.control-documentos.modules#ControlCertifcacionesModule',
                data: {titulo: 'Control de certificados'}
            },
            {
                path: 'organigrama_funcional',
                loadChildren:'./modules/organigrama-funcional/app.organigrama-funcional.modules#OrganigramaFuncionalModule',
                data: {titulo : 'Organigrama funcional'}

            },
            {
                path: 'plan_formacion',
                loadChildren:'./modules/plan-formacion/app.plan-formacion.module#PlanFormacionModule',
                data: {titulo : 'Plan anual de formación y control de acción formativa'}

            },
            {
                path: 'encuesta_higiene',
                loadChildren:'./modules/encuesta-higiene/app.encuesta-higiene.modules#EncuestaHigieneModule',
                data: {titulo : 'Anexo V Encuesta de higiene'}

            },
            {
                path: 'control_drencher',
                loadChildren:'./modules/control-drencher/app.control-drencher.modules#ControlDrencherModule',
                data: {titulo : 'Anexo III Control Productos Postcosecha Drencher'}

            },

            {
                path: 'entidades',
                loadChildren:'./modules/entidades/app.entidades.module#EntidadesModule',
                data: {titulo : 'Entidades'}

            },
             {
                path: 'transacciones',
                loadChildren:'./modules/transacciones/app.transacciones.module#TransaccionesModule',
                data: {titulo : 'Transacciones'}

            },

            {
                path: 'limpieza_cajones',
                loadChildren:'./modules/control-limpieza-cajones/app.limpieza-cajones-modules#ControlLimpiezaCajonesModule',
                data: {titulo : 'Registro limpieza cajones'}

            },
            {
                path: 'micro_fomesa',
                loadChildren:'./modules/control-fomesa/app.micro-fomesa-modules#ControlMicroFomesaModule',
                data: {titulo : 'Micro-Fomesa'}

            },
            {
                path: 'microbiologico',
                loadChildren:'./modules/analisis-microbiologico/app.microbiologico.modules#MicrobiologicoModule',
                data: {titulo : 'Análisis microbiológico'}
            },
            {
                path: 'multiresiduos',
                loadChildren:'./modules/multiresiduos/app.multiresiduos.modules#MultiresidusosModule',
                data: {titulo : 'Multiresiduos'}


            },
            {
                path: 'fruto_hueso',
                loadChildren:'./modules/fruto-hueso/app.fruto-hueso.modules#FrutoHuesoModule',
                data: {titulo : 'Fruta hueso'}

            },
            {
                path: 'calibre',
                loadChildren:'./modules/calibre/app.calibre.modules#AppCalibreModule',
                data: {titulo : 'Calibre'}
            },
            {
                path: 'control_auditoria',
                loadChildren:'./modules/control-auditoria/app.control-auditoria.modules#ControlAuditoriasModule',
                data: {titulo : 'Control auditoría'}

            },
            {
                path: 'fruto_hueso_no_conformidad',
                loadChildren:'./modules/fruto-hueso-no-conformidad/app.fruto-hueso-no-conformidad.modules#FrutoHuesoNoConformidadModule'

            },
            {
                path: 'balance_control',
                loadChildren:'./modules/balance-control/app.balance-control.modules#BalanceControlModule',
                data: {titulo : 'Balance control de producción diferenciada'}

            },
            {
                path: 'balance_masas',
                loadChildren:'./modules/balance-masas/app.balance-masas.module#BalanceMasasModule',
                data: {titulo : 'Balance de masas'}

            },
            {
                path: 'balance_global',
                loadChildren:'./modules/balance-global/app.balance-global.module#BalanceGlobalModule',
                data: {titulo : 'Balance de masas Global GAP'}

            },
            {
                path: 'control_horario',
                loadChildren:'./modules/control-horario/app.control-horario.module#ControlHorarioModule',
                data: {titulo : 'Control horario fruta externa'}

            },
            {
                path: 'analisis_agua',
                loadChildren:'./modules/analisis-agua/app.analisis-agua.module#AnalisisAguaModule',
                data: {titulo : 'Análisis de agua'}

            },
            {
                path: 'factura_agua',
                loadChildren:'./modules/factura-agua/app.factura-agua.module#FacturaAguaModule',
                data: {titulo : 'Consumo agua potable'}

            },
            {
                path: 'factura_gas',
                loadChildren:'./modules/factura-gas/app.factura-gas.module#FacturaGasModule',
                data: {titulo : 'Consumo gas'}

            },
            {
                path: 'factura_luz',
                loadChildren:'./modules/factura-luz/app.factura-luz.module#FacturaLuzModule',
                data: {titulo : 'Consumo electricidad'}

            },
            {
                path: 'materia_activa',
                loadChildren:'./modules/materia-activa/app.materia-activa.modules#AppMateriaActivaModule',
                data: {titulo : 'Materia activa'}
            },
            {
                path: 'almacenes',
                loadChildren:'./modules/almacenes/app.almacenes.module#AppAlmacenesModule',
                data: {titulo : 'Almacenes'}
            },
            {
                path: 'plan_auditoria',
                loadChildren:'./modules/plan-auditoria/app.plan-auditoria.modules#PlanAuditoriaModule',
                data: {titulo : 'Plan de auditoria'}
            },
            {
                path: 'sga_productos',
                loadChildren:'./modules/SGAproductos/app.sgaproductos.modules#SGAproductosModule'
            },
            {
                path: 'sga_proveedores',
                loadChildren:'./modules/SGAproveedores/app.sgaproveedores.modules#SGAproveedoresModule'
            },
            {
                path: 'sga_ordenes_compra',
                loadChildren:'./modules/SGAordenes_compra/app.sgaordenes_compra.modules#SGAordenes_compraModule'
            },
            {
                path: 'ubicacion',
                component: UbicacionCategoriaComponent,
                loadChildren:'./modules/SGAubicacion/app.ubicacion.modules#UbicacionModule',
                data: {titulo : 'Ubicación'},
            },
            {
                path: 'app_proveedores',
                loadChildren: './modules/app_proveedores/app.app_proveedores.modules#AppProveedoresModule',
                data: {titulo : 'Proveedores'}
            },
            {
                path: 'app_productos',
                loadChildren:'./modules/app_productos/app.app_productos.modules#AppProductosModule',
                data: {titulo : 'Productos'}
            },
            {
                path: 'envases',
                loadChildren:'./modules/envases/envases.module#EnvasesModule',
                data: {titulo : 'Envases'}
            },
            {
                path: "logs",
                loadChildren:
                "./modules/logs/logs.module#AppLogsModule",
                data: { titulo: "Logs" },
            },

        ]
    },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
      },

    { path: '**', redirectTo: 'login' },
];

let auxMenu = rellenarMenUsuario();

// routes.filter(it => it.path === 'dashboard').map(it => it.children)[0].forEach((child, index) => {
//     auxMenu.forEach(ruta => {
//         if (ruta.id.localeCompare(child.path) === 0) {
//             routes[2].children[index].data = { titulo: ruta.text || '', id: ruta.id, database: ruta.database };
//         }
//     });
// });

// -------------------
const auxMenuMap = auxMenu.reduce((acc, ruta) => {
    acc[ruta.id] = ruta;
    return acc;
}, {});

const dashboardRoute = routes.find(it => it.path === 'dashboard');
const dashboardChildren = dashboardRoute ? dashboardRoute.children : [];

dashboardChildren.forEach((child, index) => {
    const ruta = auxMenuMap[child.path];
    if (ruta) {
        routes[2].children[index].data = { titulo: ruta.text || '', id: ruta.id, database: ruta.database };
    }

});

// -------------------


// const auxMenuMap = auxMenu.reduce((acc, ruta) => {
//     acc[ruta.id] = ruta;
//     return acc;
// }, {});

// const dashboardRoute = routes.find(it => it.path === 'dashboard');
// const dashboardChildren = dashboardRoute ? dashboardRoute.children : [];

// dashboardChildren.forEach((child, index) => {
//     const ruta = auxMenuMap[child.path];
//     if (ruta) {
//         dashboardChildren[index].data = {
//             titulo: ruta.text || '',
//             id: ruta.id,
//             database: ruta.database
//         };
//     }
// });

// console.log('Modified Routes:', routes);




@NgModule({
    imports: [RouterModule.forRoot(routes )],
    exports: [RouterModule]
})
export class AppRoutingModule {}
